module.exports = __webpack_public_path__ + "static/media/logo2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo2.png
// module id = 76
// module chunks = 0